import { Env, EnvironmentVariables } from '../types/environment.types';

export const environment = new Env<EnvironmentVariables>({
  buildType: 'production',
  name: 'production',
  apiBaseUrl: '',
  allowedDomains: [],
});
